import React, { useState, useEffect } from 'react';
import './index.css'; // Assuming global styles are here
import Welcome from './components/Welcome';
import Question from './components/Question'; // Assuming this is your quiz component
import quizData from './quizData';

// Calculate maximum possible score once
const maxPossibleScore = quizData.questions.reduce((total, question) => {
  const maxPointsForQuestion = Math.max(...question.options.map(opt => opt.points));
  return total + maxPointsForQuestion;
}, 0);

function App() {
  const [quizState, setQuizState] = useState({
    started: false,
    nickname: '',
    grade: '',
    currentQuestionIndex: 0,
    score: 0,
    showExplanationForIndex: null, // Stores index of question whose explanation is shown
    explanationText: '',
    quizCompleted: false,
    resultMessage: '',
  });

  // Effect to calculate result message when quiz is completed
  useEffect(() => {
    if (quizState.quizCompleted) {
      const userScore = quizState.score;
      let message = 'Nie znaleziono odpowiedniej wiadomości dla wyniku.'; // Default message
      for (const result of quizData.results) {
        if (userScore >= result.min_score && userScore <= result.max_score) {
          message = result.summary;
          break;
        }
      }
      setQuizState(prev => ({ ...prev, resultMessage: message }));
    }
  }, [quizState.quizCompleted, quizState.score]);

  const handleStartQuiz = (nickname, grade) => {
    setQuizState({
      ...quizState,
      started: true,
      nickname: nickname,
      grade: grade,
      currentQuestionIndex: 0,
      score: 0,
      showExplanationForIndex: null,
      explanationText: '',
      quizCompleted: false,
      resultMessage: '',
    });
  };

  const handleAnswerSubmit = (points, explanation) => {
    setQuizState(prev => ({
      ...prev,
      score: prev.score + points, // Assuming points are 1 for correct, 0 for incorrect
      showExplanationForIndex: prev.currentQuestionIndex,
      explanationText: explanation,
    }));
  };

  const handleNextQuestionOrFinish = () => {
    if (quizState.currentQuestionIndex < quizData.questions.length - 1) {
      setQuizState(prev => ({
        ...prev,
        currentQuestionIndex: prev.currentQuestionIndex + 1,
        showExplanationForIndex: null,
        explanationText: '',
      }));
    } else {
      setQuizState(prev => ({
        ...prev,
        quizCompleted: true,
        showExplanationForIndex: null, // Clear explanation state on finish
        explanationText: '',
      }));
    }
  };

  if (quizState.quizCompleted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-white text-gray-800">
        <div className="bg-white shadow-xl rounded-xl p-8 max-w-2xl w-full text-center border border-gray-200">
          <h1 className="text-4xl font-bold mb-6 text-digital-orange filter drop-shadow-sm">Quiz Zakończony!</h1>
          <p className="mb-4 text-xl text-gray-700">Gratulacje, {quizState.nickname} ({quizState.grade})!</p>
          <p className="mb-4 text-2xl font-semibold text-gray-800">
            Twój wynik: {quizState.score} / {maxPossibleScore}
          </p>
          <div className="mb-8 p-4 bg-orange-50 rounded-lg border border-orange-200 text-gray-700 text-left whitespace-pre-line">
            <p>{quizState.resultMessage}</p>
          </div>
          <button
            onClick={() => handleStartQuiz(quizState.nickname, quizState.grade)} // Optionally prefill nickname/grade for restart
            className="w-full btn btn-primary text-lg py-3 shadow-lg transform hover:scale-105 transition duration-150"
          >
            Spróbuj Ponownie
          </button>
        </div>
      </div>
    );
  }

  if (!quizState.started) {
    return <Welcome onStartQuiz={handleStartQuiz} />;
  }

  const currentQuestion = quizData.questions[quizState.currentQuestionIndex];

  return (
    <Question 
      question={currentQuestion}
      questionNumber={quizState.currentQuestionIndex + 1}
      totalQuestions={quizData.questions.length}
      onAnswerSubmit={handleAnswerSubmit} 
      isExplanationVisible={quizState.showExplanationForIndex === quizState.currentQuestionIndex}
      explanationTextToShow={quizState.explanationText}
      onProceed={handleNextQuestionOrFinish}
    />
  );
}

export default App; 